import React, { useContext } from 'react';
import { BiFilterAlt } from 'react-icons/bi';
import styled from 'styled-components';
import { SaveStrategyForLater } from '@/features/editor/widgets/custom-widget/loading-section/strategy-per-slot/saved-strategy/save-strategy';
import { SlotState } from '@/features/editor/widgets/custom-widget/loading-section/shared/models';
import { LoadStrategy } from '@/features/editor/widgets/custom-widget/loading-section/strategy-per-slot/saved-strategy/load-strategy';
import { UpdateStrategy } from '@/features/editor/widgets/custom-widget/loading-section/strategy-per-slot/saved-strategy/update-strategy';
import { EditorContext } from '@/features/editor/context/editor-context';
import { StrategyPerSlotContext } from '@/features/editor/widgets/custom-widget/loading-section/strategy-per-slot/context/context';
import { LayeredRulingContext } from '@/features/editor/widgets/custom-widget/loading-section/layered-ruling/context';

type Props = {
  openGlobal: () => void;
  onSaveStrategy: (label: string) => void;
  onUpdateStrategy: (id: string) => void;
  onDeleteStrategy: (id: string) => void;
  setStrategy: (s: SavedStrategy) => void;
  strategies?: SavedStrategies;
  isGlobalFilterApplied?: boolean;
};

export type SavedStrategies = Array<SavedStrategy>;

export type SavedStrategy = {
  name: string;
  id: string;
  slots: Array<SlotState>;
};

export type SavedStrategyReq = {
  name?: string;
  id?: string;
  slots: { slots: Array<SlotState> };
};

export function SavedFiltersManual({
  openGlobal,
  onSaveStrategy,
  setStrategy,
  strategies,
  onUpdateStrategy,
  onDeleteStrategy,
  isGlobalFilterApplied,
}: Props) {
  const { isPostPurchase: sPostPurchase } = useContext(StrategyPerSlotContext);
  const { isPostPurchase: lPostPurchase } = useContext(LayeredRulingContext);
  const { currentExtension } = useContext(EditorContext);
  const isPostPurchase = sPostPurchase || lPostPurchase;
  const isCheckout = currentExtension === `shopify-checkout-extensibility`;
  return (
    !isPostPurchase && (
      <Wrapper>
        <GlobalButton
          isGlobalFilterApplied={isGlobalFilterApplied}
          type="button"
          onClick={openGlobal}
        >
          <BiFilterAlt size={20} />
          {isGlobalFilterApplied ? (
            <p>Global Filter (Applied)</p>
          ) : (
            <p>Add a Global Filter</p>
          )}
        </GlobalButton>
        {!isCheckout && (
          <>
            <LoadStrategy
              setStrategy={setStrategy}
              onDeleteStrategy={onDeleteStrategy}
              strategies={strategies}
            />
            <SaveStrategyForLater onSaveStrategy={onSaveStrategy} />
            <UpdateStrategy
              onUpdateStrategy={onUpdateStrategy}
              strategies={strategies}
            />
          </>
        )}
      </Wrapper>
    )
  );
}

const Wrapper = styled.div`
  display: flex;
  gap: 3rem;
  justify-content: center;
  align-items: center;

  && > button {
    display: flex;
    gap: 0.7rem;
    align-items: center;
    color: #798794;
    cursor: pointer;
  }

  && > button:hover {
    color: #000;
  }

  && > button > p {
    margin: 0;
    font-weight: 500;
    font-size: 13px;
  }
`;

const GlobalButton = styled.button`
  color: ${(p: { isGlobalFilterApplied: boolean }) =>
    p.isGlobalFilterApplied ? `#0062ff` : `#798794`}!important;

  &&:hover {
    color: ${(p: { isGlobalFilterApplied: boolean }) =>
      p.isGlobalFilterApplied ? `#0044bf` : `#000`}!important;
  }
`;
